import { render, staticRenderFns } from "./register.vue?vue&type=template&id=7b37abd2&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=7b37abd2&prod&scoped=true&lang=less"
import style1 from "./register.vue?vue&type=style&index=1&id=7b37abd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37abd2",
  null
  
)

export default component.exports